const socSecCheckupSymbols = "0123456789ABCDEFHJKLMNPRSTUVWXYZ";
const centuryRE = /^[+\-YXWVUABCDEF]$/i; // socSec century symbols

export function validateSocSec(socSec) {
  if (!socSec || socSec === "") {
    return true;
  }

  if (socSec.length !== 11) {
    return false;
  }

  const ddmmyy = socSec.substring(0, 6); // date is validated only in backend
  const century = socSec.substring(6, 7);
  if (!centuryRE.test(century)) return false;
  const nnn = socSec.substring(7, 10);
  const t = socSec.substring(10, 11);

  const checksum = parseInt(ddmmyy + nnn);
  const remainder = checksum % 31;

  const checkupSymbol = socSecCheckupSymbols.substring(remainder, remainder + 1);

  return checkupSymbol === t;
}


// Business ID validation
export function validateYtunnus(id) {
  if (!id || id === "") {
    return true;
  }

  if (id.length !== 9) {
    return false;
  }

  const remainder = (id[0]*7 + id[1]*9 + id[2]*10 + id[3]*5 + id[4]*8 + id[5]*4 + id[6]*2) % 11;

  if (remainder === 1) return false;
  if (remainder === 0 && id[8] === "0") return true;
  if (remainder > 1 && remainder < 11) {
    if ( 11 - remainder === Number(id[8]) ) return true;
  }

  return false;
}


export function determineIdentifierCodeType(identifierCode) { // check socSec and set gender
  if (!identifierCode) return undefined; // empty identifier
  if (identifierCode.length === 9 && validateYtunnus(identifierCode)) {
    return "Y"; // Y-tunnus
    //return "O"; // Osakeyhtiö
  }
  else if (identifierCode.length === 11 && validateSocSec(identifierCode)) {
    if (identifierCode[7] === "9") {
      return "K"; // Tilapäinen yksilöintitunnus
    }
    if (identifierCode.slice(-2, -1) % 2) {
      return "M";
    } else {
      return "N";
    }
  }
  return false;
}


const whitespaceRE = /\s/g;
const ibanRE = /[A-Z]/g;
const ibanReplacer = match => match.charCodeAt() - 55;

const IBAN_LENGTHS = { // https://www.iban.com/structure
  AD: 24, AE: 23, AL: 28, AT: 20, AZ: 28, BA: 20, BE: 16, BG: 22, BH: 22, BI: 27, BR: 29, BY: 28,
  CH: 21, CR: 22, CY: 28, CZ: 24, DE: 22, DJ: 27, DK: 18, DO: 28, EE: 20, EG: 29, ES: 24,
  FI: 18, FO: 18, FR: 27, GB: 22, GE: 22, GI: 23, GL: 18, GR: 27, GT: 28, HR: 21, HU: 28,
  IE: 22, IL: 23, IQ: 23, IS: 26, IT: 27, JO: 30, KW: 30, KZ: 20,
  LB: 28, LC: 32, LI: 21, LT: 20, LU: 20, LV: 21, LY: 25,
  MC: 27, MD: 24, ME: 22, MK: 19, MR: 27, MT: 31, MU: 30, NL: 18, NO: 15,
  PK: 24, PL: 28, PS: 29, PT: 25, QA: 29, RO: 24, RS: 22, RU: 33,
  SA: 24, SC: 31, SD: 18, SE: 24, SI: 19, SK: 24, SM: 27, ST: 25, SV: 28,
  TL: 23, TN: 24, TR: 26, UA: 29, VA: 22, VG: 24, XK: 20,
};

export function validateIban(iban) {
  if (!iban || iban === "") {
    return true;
  }

  const ibanTrimmed = iban.replace(whitespaceRE, "").toUpperCase();
  const countryIdentifier = ibanTrimmed.substring(0, 2);
  if (ibanTrimmed.length !== IBAN_LENGTHS[countryIdentifier]) {
    return false;
  }
  const checkDigits = ibanTrimmed.substring(2, 4);
  const accountNumber = ibanTrimmed.substring(4);
  const checkupAccount = (accountNumber + countryIdentifier + checkDigits).replace(ibanRE, ibanReplacer);

  let checksum = checkupAccount.slice(0, 2), fragment;
  for (let offset = 2; offset < checkupAccount.length; offset += 7) {
    fragment = String(checksum) + checkupAccount.substring(offset, offset + 7);
    checksum = parseInt(fragment, 10) % 97;
  }

  return checksum === 1;
}

const bicPattern = /^[A-Z]{4}([A-Z]{2})[A-Z0-9]{2}(?:[A-Z0-9]{3})?$/; // bank{4}, country{2}, location{2}, branch{3}?
export function validateBic(bic) {
  if (!bic || bic === "") {
    return true;
  }

  const matches = bic.match(bicPattern);
  if (matches === null || IBAN_LENGTHS[ matches[1] ] === undefined) { // validate country code
    return false;
  }

  return true;
}

const emailRFC6532Pattern = /^("(?:[!#-[\]-\u{10FFFF}]|\\[\t -\u{10FFFF}])*"|[!#-'*+\-/-9=?A-Z^-\u{10FFFF}](?:\.?[!#-'*+\-/-9=?A-Z^-\u{10FFFF}])*)@([!#-'*+\-/-9=?A-Z^-\u{10FFFF}](?:\.?[!#-'*+\-/-9=?A-Z^-\u{10FFFF}])*|\[[!-Z^-\u{10FFFF}]*\])$/u;
export function validateEmail(email) {
  if (!email || email === "") {
    return true;
  }

  return emailRFC6532Pattern.test(email);
}
